import chmln from '@chamaeleonidae/chmln';
import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';

import {
  RELEASE,
  SERVER,
  DATADOG_CLIENT_TOKEN,
  DATADOG_RUM_APP_ID,
  DATADOG_RUM_CLIENT_TOKEN,
  DATADOG_SERVICE,
  CHAMELEON_TOKEN,
} from 'constants/all';

import { GlobalStore } from 'store/configureStore';

const initializeFullStory = () => {
  /* eslint-disable */
  window['_fs_debug'] = false;
  window['_fs_host'] = 'fullstory.com';
  window['_fs_org'] = 'HS201';
  window['_fs_namespace'] = 'FS';
  window['_fs_script'] = 'edge.fullstory.com/s/fs.js';
  (function (m, n, e, t, l, o, g, y) {
    if (e in m) {
      if (m.console && m.console.log) {
        m.console.log(
          'FullStory namespace conflict. Please set window["_fs_namespace"].',
        );
      }
      return;
    }
    g = m[e] = function (a, b, s) {
      g.q ? g.q.push([a, b, s]) : g._api(a, b, s);
    };
    g.q = [];
    o = n.createElement(t);
    o.async = 1;
    o.src = 'https://' + _fs_script;
    y = n.getElementsByTagName(t)[0];
    y.parentNode.insertBefore(o, y);
    g.identify = function (i, v, s) {
      g(l, { uid: i }, s);
      if (v) g(l, v, s);
    };
    g.setUserVars = function (v, s) {
      g(l, v, s);
    };
    g.event = function (i, v, s) {
      g('event', { n: i, p: v }, s);
    };
    g.shutdown = function () {
      g('rec', !1);
    };
    g.restart = function () {
      g('rec', !0);
    };
    g.consent = function (a) {
      g('consent', !arguments.length || a);
    };
    g.identifyAccount = function (i, v) {
      o = 'account';
      v = v || {};
      v.acctId = i;
      g(o, v);
    };
    g.clearUserCookie = function () {};
  })(window, document, window['_fs_namespace'], 'script', 'user');
  /* eslint-enable */
};

const initializeChameleon = () => chmln.init(CHAMELEON_TOKEN);

const initializeDatadog = () => {
  if (DATADOG_CLIENT_TOKEN) {
    datadogLogs.init({
      clientToken: DATADOG_CLIENT_TOKEN,
      forwardErrorsToLogs: true,
      service: DATADOG_SERVICE,
      version: RELEASE,
      env: SERVER,
      sampleRate: 100,
      useSecureSessionCookie: true,
      beforeSend: (log) => {
        log.userGroup = GlobalStore.getState().auth.user?.group?.locator;
      },
    });
  }
  if (DATADOG_RUM_CLIENT_TOKEN && DATADOG_RUM_APP_ID) {
    datadogRum.init({
      applicationId: DATADOG_RUM_APP_ID,
      clientToken: DATADOG_RUM_CLIENT_TOKEN,
      // `site` refers to the Datadog site parameter of your organization
      // see https://docs.datadoghq.com/getting_started/site/
      site: 'datadoghq.com',
      service: DATADOG_SERVICE,
      env: SERVER,
      version: RELEASE,
      sessionSampleRate: 100,
      // setting this disables session recording
      sessionReplaySampleRate: 0,
      defaultPrivacyLevel: 'mask',
      trackUserInteractions: true,
      useSecureSessionCookie: true,
    });
  }
};

export const chameleon = {
  identify: (id, options) => {
    chmln.identify(id, options);
  },
};

export const initializeThirdParty = () => {
  if (SERVER !== 'local') initializeFullStory();

  initializeDatadog();
  initializeChameleon();
};
